export default __webpack_public_path__ + "media/images/images/logo/logo-dark-4eddf448db6f55651aed5520ad67ea52.png";